<template>
  <div :class="field.classes()">
    <div :class="field.classes('label', true)" v-if="label">
      {{label}}
      <span :class="field.classes('required-star', true)" v-if="required">*</span>
    </div>
    <errors v-if="error.length" :error="error"></errors>
    <div :class="field.classes('container')">

      <div :class="field.classes('anchor')" v-if="anchorField">
        <active-field
          v-model="anchorValue"

          ref="anchorField"

          :name="anchorField.fieldName"
          :field="anchorField"
          :scope="{...scope, listValues:value}"
          :formScope="formScope"
          :rootScope="rootScope"

          @input="onAnchorInput($event)"
        ></active-field>
      </div>

      <div :class="field.classes('list')" v-if="value && value.length>0">
        <div :class="field.classes('list__item')" v-for="(row, index) in value" :key="index">
          <div :class="field.classes('list__anchor')" v-if="anchorField">
            <active-field
              v-model="row[anchorField.fieldName]"

              :name="anchorField.fieldName"
              :field="anchorField"
              :readOnly="true"
              :scope="row"
              :formScope="formScope"
              :rootScope="rootScope"
            ></active-field>
            <div :class="field.classes('list__anchor__delete')" @click="deleteItem(index)">
              <ui-inline-icon
                icon="trash"
                :class="field.classes('selected-item__arrow')"></ui-inline-icon>
            </div>
          </div>
          <div :class="field.classes('list__row')">
            <active-field
              v-model="row[rowField.fieldName]"
              v-for="rowField in field.fields" :key="rowField.fieldName"
              v-show="!rowField.options.hidden"

              :name="rowField.fieldName"
              :error="colErrors(rowField.fieldName,index)"
              :field="getRowField(index,rowField.fieldName)"
              :scope="row"
              :formScope="formScope"
              :rootScope="rootScope"

              @input="onInput(index, rowField.fieldName, $event)"
            ></active-field>
          </div>
          <div v-if="!anchorField" class="cabinet-add__delete-workplace-btn" @click="deleteItem(index)">
            {{ $t('labels.delete') }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="!anchorField" class="cabinet-add__add-workplace-btn" @click="addItem()">
      {{ $t('labels.add') }} {{fieldOptions.addText}}
    </div>
  </div>
</template>

<script>
  import {fieldProps} from '../BZCore/ActiveField'
  import Errors from '../errors.vue'

  export default {
    name: 'DynamicListField',
    props: fieldProps,
    components: {Errors},
    data () {
      return {
        anchorValue: ''
      }
    },
    created () {
      if (!this.value) {
        this.$emit('input', [])
      }
    },
    methods: {
      getRowField (rowIndex, fieldName) {
        return this.field.getRowField(rowIndex, fieldName)
      },
      cloneValue () {
        if (!Array.isArray(this.value)) {
          return []
        } else {
          return _.cloneDeep(this.value)
        }
      },
      colErrors (colName, rowIndex) {
        const fieldName = [this.field.fieldName, rowIndex, colName].join('.')
        const errors = []
        for (const error of this.field.form.errors) {
          if (error.field === fieldName) {
            errors.push(error)
          }
        }
        return errors
      },
      async addItem (defaultValue) {
        if (!defaultValue) {
          defaultValue = await this.getEmptyRow()
        }
        const newValue = this.cloneValue()
        newValue.push(defaultValue)
        this.$emit('input', newValue)
      },
      deleteItem (index) {
        const newValue = this.cloneValue()
        newValue.splice(index, 1)
        this.$emit('input', newValue)
      },
      onInput (index, col, value) {
        const newValue = this.cloneValue()
        this.$set(newValue[index], col, value)
        this.$emit('input', newValue)
      },
      async getEmptyRow () {
        const row = {}
        for (const fieldName in this.field.fields) {
          if (this.field.fields.hasOwnProperty(fieldName)) {
            this.$set(row, fieldName, await (this.field.fields[fieldName].initialValue(row)))
          }
        }
        if (this.field.anchorField) {
          row[this.field.anchorField.fieldName] = ''
        }
        return row
      },
      async onAnchorInput (value) {
        const row = await this.getEmptyRow()
        this.$set(row, this.anchorField.fieldName, value)
        this.addItem(row)
        this.anchorValue = ''
      }
    },
    computed: {
      anchorField () {
        return this.field.anchorField
      },
      multiSelect () {
        return !!this.options.multiSelect
      },
      errorMessage () {
        const text = []
        for (const error of this.error) {
          text.push(error.message)
        }
        return text.join(', ')
      }
    }
  }
</script>

<style lang="scss">
  .active-field--dynamic-list {
    .active-field-error_list {
      display: none;
    }

    &__label {
      font-size: 14px;
      color: #303133;
      margin-bottom: 10px;
    }

    &__anchor {
      .active-field--model-select__placeholder {
        color: #2F80ED;
      }

      .active-field--model-select__label {
        display: none;
      }
    }

    &__list {
      background: #F9FAFC;
      margin: 0 -20px;
      padding: 20px;

      &__anchor {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 15px;

        > .active-field {
          flex-grow: 1;
          margin-bottom: 0;
          min-width: 0;
        }

        &__delete {
          margin-top: 25px;
          margin-left: 16px;
          cursor: pointer;
        }
      }

      &__item {
        border-bottom: 1px solid #E4E7ED;
        margin-bottom: 15px;

        &:last-child {
          border-bottom: 0;
        }
      }

      &__row {
        display: flex;
        min-width: 0;

        > * {
          flex-shrink: 1;
          margin: 0 5px;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .active-form--small {
    .active-field--dynamic-list {

    }
  }
</style>